import { render } from "./BlockFixedButtons.vue?vue&type=template&id=49750326&scoped=true"
import script from "./BlockFixedButtons.vue?vue&type=script&lang=js"
export * from "./BlockFixedButtons.vue?vue&type=script&lang=js"

import "./BlockFixedButtons.vue?vue&type=style&index=0&id=49750326&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49750326"]])

export default __exports__